import React, { useState } from 'react';
import { Tooltip, TooltipProps, useMediaQuery, useTheme, Button } from '@mui/material';
import styleVariables from '../styles/styleVariables';
import CAppDialog from './CAppDialog';

const CAppTooltip = (props: TooltipProps) => {
	const theme = useTheme();

	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
	const [open, setOpen] = useState(false);
	return (
		<>
			<Tooltip
				onClick={() => (isMobile ? setOpen(true) : null)}
				{...props}
				title={isMobile ? '' : props.title}
				arrow
				componentsProps={{
					tooltip: {
						sx: {
							fontSize: '0.9rem',
							fontWeight: 400,
							padding: '8px',
							bgcolor: theme.palette.mode === 'dark' ? '#FFF' : styleVariables.primaryColor,
							color: theme.palette.mode === 'dark' ? styleVariables.primaryColor : '#FFF',
							border: '1px solid #F2F2F2',
							'& .MuiTooltip-arrow': {
								color: theme.palette.mode === 'dark' ? '#FFF' : styleVariables.primaryColor,
								'&:before': {
									border: '1px solid #F2F2F2',
								},
							},
						},
					},
				}}
			>
				{props.children}
			</Tooltip>
			{isMobile ? (
				<CAppDialog
					open={open}
					actions={
						<Button variant="contained" color="secondary" onClick={() => setOpen(false)}>
							OK
						</Button>
					}
				>
					<div>{props.title}</div>
				</CAppDialog>
			) : (
				''
			)}
		</>
	);
};

export default CAppTooltip;
